import { FetchError } from '@nzyme/fetch-utils/FetchError.js';
import { toJsonString } from '@nzyme/utils/toJsonString.js';
import { RpcError } from './types/RpcError.js';
/**
 * Create an RPC client function.
 * @__NO_SIDE_EFFECTS__
 */
export function createClient(clientOptions) {
    return async (endpoint, ...args) => {
        const [input, options] = args;
        const request = await clientOptions.request(endpoint, options);
        const headers = {
            'Content-Type': 'application/json',
            ...request.headers,
        };
        const body = toJsonString(input);
        const response = await fetch(request.url, {
            method: 'POST',
            body,
            headers: headers,
        });
        if (!response.ok) {
            if (response.headers.get('content-type')?.includes('application/json')) {
                const data = (await response.json());
                // No console output here: `input` is the request payload, which on a domain client
                // carries whatever the endpoint takes, and a raw `console.*` bypasses the caller's
                // logger and any redaction wrapped around it. The thrown `RpcError` already carries
                // `data`, so the caller decides what to record and through which sink.
                throw new RpcError(response, data);
            }
            const message = await response.text();
            throw new FetchError(response, message);
        }
        return (await response.json());
    };
}
//# sourceMappingURL=createClient.js.map